import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  constructor() {
    const isDarkMode = localStorage.getItem('pi-signage-theme') === 'dark';
    document.documentElement.classList.toggle('app-dark', isDarkMode);
  }
}
